import React, { useEffect, useContext } from "react";
import { useToasts } from "react-toast-notifications";
import {ErrorContext} from '../../Contexts/ErrorContext'



const Toasts = () => {
    const { addToast } = useToasts();

    const {isMainSuccess, errors} = useContext(ErrorContext);
    useEffect(() => {
      if (isMainSuccess) {
        addToast("Actualización realizada", { appearance: "success" });
      }
    }, [isMainSuccess]);

    useEffect(() => {
      if (errors.length) {
        errors.forEach((error) => addToast(error, { appearance: "error" }));
      }
    }, [errors]);

    return <div />;
};

export default Toasts


// WEBPACK FOOTER //
// ./src/Containers/Main/Toasts.js